/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_CourseInputs */

const en__field_course = /** @type {(inputs: _Field_CourseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Course`)
};

/**
* | output |
* | --- |
* | "Course" |
*
* @param {_Field_CourseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const _field_course = /** @type {((inputs?: _Field_CourseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_CourseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_course(inputs)
});